<template lang="html">
  <div>
    <form>
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"                
              label="Name"
            />
          </v-col>

          <v-col cols="12">
            <!-- <v-autocomplete 
              v-model="jobGrade"
              v-validate="'required'"
              :items="jobGrades"
              label="Job Grade"
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('jobGrade')"
              data-vv-name="jobGrade"
              data-vv-as="job grade"
            /> -->
            <!-- <v-autocomplete 
              v-model="positionGroup"
              v-validate="'required'"
              :items="positionGroups"
              label="Position Group"
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('positionGroup')"
              data-vv-name="positionGroup"
              data-vv-as="position group"
            /> -->
          </v-col>

          <!-- <v-col cols="12">
            <v-autocomplete 
              v-model="positionCategory"
              v-validate="'required'"
              :items="positionCategories"
              label="Position Category"
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('positionCategory')"
              data-vv-name="positionCategory"
              data-vv-as="position category"
            /> 
          </v-col>-->
         
          <!--<v-col cols="12">
             <v-row no-gutters>
              <v-col
                cols="2"
                class="ma-auto"
              >
                <span style="font-size:16px">
                  Rank From
                </span>
              </v-col>

              <v-col>
                <v-autocomplete
                  v-model="rankFrom"
                  :items="filteredRanks"
                  item-text="pivot.name"
                  item-value="pivot.id"
                  hide-no-data
                  hide-selected
                >
                  <template v-slot:selection="data">
                    <v-chip :input-value="data.selected">
                      <v-avatar
                        rounded
                        left
                      >
                        <img :src="data.item.image_url">
                      </v-avatar>
                      {{ data.item.pivot.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile>
                        <img :src="data.item.image_url">
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.pivot.name" />
                        <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col
                class="ma-auto"
                cols="1"
              >
                <span style="font-size:16px;margin-left:12px">
                  To
                </span>
              </v-col>

              <v-col>
                <v-autocomplete
                  v-model="rankTo"
                  :items="ranksTo"
                  item-text="pivot.name"
                  item-value="pivot.id"
                  hide-no-data
                  hide-selected
                >
                  <template v-slot:selection="data">
                    <v-chip :input-value="data.selected">
                      <v-avatar
                        rounded
                        left
                      >
                        <img :src="data.item.image_url">
                      </v-avatar>
                      {{ data.item.pivot.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile>
                        <img :src="data.item.image_url">
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.pivot.name" />
                        <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row> 
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="success"          
            @click="goNext"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </form>
  </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        name: '',
        jobGrade: null,
        jobGrades: [],
        //     positionGroup: null,
        //     positionGroups: [],
        //     positionCategory: null,
        //     rankFrom: null,
        //     rankTo: null,
      }
    },
    // computed: {
    //   positionCategories () {
    //     if (!this.positionGroup) return 

    //     return this.positionGroups.find(item => { return item.id === this.positionGroup }).position_categories
    //   },

    //   filteredRanks () {
    //     if (!this.positionCategories || !this.positionCategory) return

    //     return this.positionCategories.find(item => item.id === this.positionCategory).ranks
    //   },

    //   ranksTo () {
    //     if (!this.rankFrom || !this.positionCategories) return 
 
    //     return this.filteredRanks.filter(item => { return item.pivot.id >= this.rankFrom })
    //   },
    // },
    mounted () {
      this.loadJobGrades()
    //   this.loadPositionGroups()
    },
    methods: {
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
      goNext () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.$emit('next-step')
        })
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      getFormData () {
        return {
          name: this.name,  
          job_grade_id: this.jobGrade,   
          //       position_group_id: this.positionGroup,
          //       position_category_id: this.positionCategory,
          //       rank_from_id: this.rankFrom,
          //       rank_to_id: this.rankTo,
        }
      },
    //   loadPositionGroups () {
    //     this.$api.positionGroups().list()
    //       .then(res => {
    //         this.positionGroups = res.data
    //       })
    //   },
    },
  }
</script>
